/**
 * Design tokens shared by the mobile foundation. Mirrors
 * dev-inventory-web/src/components/list/listShared.tsx so both MFEs render
 * the same surfaces inside the host shell.
 */
export const TEAL = "#0F7679";
export const TEAL_DARK = "#0D5759";
export const TEAL_TINT = "#E7F1F1";
export const TEAL_TINT_SOFT = "#EBF0F0";
export const BORDER_SOFT = "#EBF0F0";
export const BORDER = "#DBE4E4";
export const BORDER_STRONG = "#C9D7D8";
export const TEXT = "#222525";
export const TEXT_MUTED = "#4A5353";
export const TEXT_DIM = "#6A7878";
export const DESTRUCTIVE = "#BA0E13";
export const BACKDROP = "#22252552";

export const RADIUS_PILL = "30px";
export const RADIUS_INPUT = "12px";
export const RADIUS_SHEET = "22px";

/** Minimum touch target (px). */
export const TAP = 44;
/** Input / sheet row height (px). */
export const CONTROL = 48;

/**
 * Height of the host's mobile bottom tab bar. dev-core-web defines
 * --finex-tabbar-h on :root (feat/mobile-shell-nav and later); an older shell
 * falls back to 0px and fixed chrome simply sits at the bottom edge.
 */
export const TABBAR_OFFSET = "var(--finex-tabbar-h, 0px)";
export const SAFE_BOTTOM = "env(safe-area-inset-bottom, 0px)";

/**
 * The repo's i18n pattern: look the English string up in the host-provided
 * dictionary, fall back to the English literal when the key is missing.
 */
export const t = (language: any, key: string, fallback?: string): string =>
  language?.[key] ?? fallback ?? key;
